export function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

export function getTimeZone() {
  const timezoneDefault = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const offset = new Date().getTimezoneOffset();
  const o = Math.abs(offset);
  const gmt = `${
    (offset < 0 ? '+' : '-') + `00${Math.floor(o / 60)}`.slice(-2)
  }:${`00${o % 60}`.slice(-2)}`;
  const label = `(GMT ${gmt}) ${timezoneDefault}`;
  const value = timezoneDefault;
  return {
    _id: value,
    label,
    value,
  };
}

export function formatDuration(duration) {
  let seconds = parseInt((duration / 1000) % 60);
  let minutes = parseInt((duration / (1000 * 60)) % 60);
  let hours = parseInt((duration / (1000 * 60 * 60)) % 24);

  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  seconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${hours}:${minutes}:${seconds}`;
}

export function bytesToSize(bytes) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return `${Math.round(bytes / Math.pow(1024, i), 2)} ${sizes[i]}`;
}

export function getRandomAccessCode() {
  const randomChars = '0123456789';
  let result = '';
  for (let i = 0; i < 6; i++) {
    result += randomChars.charAt(
      Math.floor(Math.random() * randomChars.length),
    );
  }
  return result;
}
export function isNumberKey(evt) {
  const charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    evt.preventDefault();
  }
}

export function numberOnlyInput(inp) {
  let number = /^[0-9\b]+$/;
  if (inp === '' || number.test(inp)) {
    return inp;
  } else {
    return '';
  }
}

export const allowDigitOnly = (e, func, string) => {
  const {
    keyCode,
    currentTarget: { value },
  } = e;
  if (
    (keyCode >= 48 && keyCode <= 57) ||
    (keyCode >= 96 && keyCode <= 105) ||
    keyCode === 8 ||
    keyCode === 46 ||
    keyCode === 37 ||
    keyCode === 39
  ) {
    func(string, value);
  } else {
    e.preventDefault();
  }
};

export const shuffleArrayWithValue = (value) => {
  let array;
  if (Array.isArray(value)) {
    array = [...value];
  } else {
    array = Array.from(Array(value), (_, index) => index + 1);
  }

  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};
